import { memo } from 'react';

import { TableToolsBar } from '@/lib/v2/organisms';

import DeleteRecurringMessageModal from './DeleteRecurringMessageModal';
import DuplicateRecurringMessageModal from './DuplicateRecurringMessageModal';
import EditRecurringMessageModal from './EditRecurringMessageModal';

import { useActionBar } from '@/modules/AutomationModuleNew/hooks/useActionBar';
import { IRecurrenceMessage } from '@/modules/CampaignsModule/interfaces/Campaigns';

interface ActionBarRecurringMessagesProps {
  totalRowSelected: number;
  dataSelected: IRecurrenceMessage[];
  refetchData: () => void;
}

const ActionBarRecurringMessages = ({
  totalRowSelected,
  dataSelected,
  refetchData,
}: ActionBarRecurringMessagesProps) => {
  const {
    actions,
    deleteModalIsOpen,
    toggleDeleteModal,
    editModalIsOpen,
    toggleEditModal,
    duplicateModalIsOpen,
    toggleDuplicateModal,
  } = useActionBar({
    totalRowSelected,
  });

  const campaignsIDs = dataSelected.map((RM) => RM.campaignId);
  const nameRecurringMessage = dataSelected[0]?.name;
  const campaignID = dataSelected[0]?.campaignId;

  return (
    <div>
      <TableToolsBar>
        {actions
          .filter((element) => !element.hide)
          .map((element) => {
            const { label, icon, tooltip, onClick: handleOnClick, id } = element;
            return (
              <TableToolsBar.Button
                key={id}
                icon={icon}
                id={id}
                label={label}
                tooltip={tooltip}
                onClick={handleOnClick}
              />
            );
          })}
      </TableToolsBar>
      {deleteModalIsOpen && (
        <DeleteRecurringMessageModal
          campaignIDs={campaignsIDs}
          isOpen={deleteModalIsOpen}
          refetchData={refetchData}
          totalRowSelected={totalRowSelected}
          onClose={toggleDeleteModal}
        />
      )}
      {editModalIsOpen && (
        <EditRecurringMessageModal
          campaignID={campaignID}
          isOpen={editModalIsOpen}
          nameRecurringMessage={nameRecurringMessage}
          refetchData={refetchData}
          onClose={toggleEditModal}
        />
      )}
      {duplicateModalIsOpen && (
        <DuplicateRecurringMessageModal
          campaignID={campaignID}
          isOpen={duplicateModalIsOpen}
          nameRecurringMessage={nameRecurringMessage}
          onClose={toggleDuplicateModal}
        />
      )}
    </div>
  );
};

export default memo(ActionBarRecurringMessages);
